import { render, staticRenderFns } from "./FxCalendario.vue?vue&type=template&id=b923b692"
import script from "./FxCalendario.vue?vue&type=script&lang=js"
export * from "./FxCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports